import segment_ids from '_constants/segment_ids.json'

export const PERCENTILE_TAXONOMY_NAME = 'Percentile Based Predictor Taxonomy'

const segment_id_options = segment_ids.map((item) => ({ value: item.code, label: item.name }))
export const FIELDS = [
  {
    name: 'name',
    type: 'text',
    position: '1/3',
    label: 'Taxonomy Name',
  },
  {
    name: 'slug',
    type: 'text',
    position: '3/6',
    label: 'Taxonomy Slug',
    description: "More url friendly taxonomy name consist of lower case and '.'",
  },
  {
    name: 'is_branded',
    type: 'checkbox',
    position: '6/7',
    label: 'Branded',
  },
  {
    name: 'name_separator',
    type: 'text',
    position: '1/3',
    label: 'Name Separator',
  },
  {
    name: 'id_sets',
    type: 'select',
    position: '3/5',
    label: 'Partner Mapping ID',
    options: segment_id_options,
    useReactSelect: true,
  },
  {
    name: 'need_mapping_ids',
    type: 'select',
    position: '5/7',
    label: 'Need New Segment IDs',
    options: [
      { value: false, label: 'No' },
      { value: true, label: 'Yes' },
    ],
    useReactSelect: true,
  },
]

export const INITIAL_STATE = {
  name: '',
  slug: '',
  is_branded: false,
  distribution: [],
  name_separator: '',
  id_sets: '',
  segments: [],
}
